import React from 'react'
import { Link } from 'react-router-dom'
import { ToolkitPageLayout } from '../../../components'

interface Breadcrumb {
  label: string
  path: string
}

export const PoliticalCollaborationPage: React.FC = () => {
  const pageTitle =
    'Collaborating with Political Leaders and Government Officials'
  const breadcrumbs: Breadcrumb[] = [
    { label: 'Toolkit', path: '/toolkit' },
    { label: 'Community', path: '/toolkit/community' },
    {
      label: pageTitle,
      path: '/toolkit/community/political-collaboration'
    }
  ]

  return (
    <ToolkitPageLayout title={pageTitle} breadcrumbs={breadcrumbs}>
      <div className="prose max-w-none text-[#3C2416]">
        <p className="text-lg mb-6">Watch videos below:</p>

        {/* Video 1 */}
        <div className="aspect-w-16 aspect-h-9 h-[50vh] w-[50vw] mx-auto mb-10 rounded-lg overflow-hidden shadow-lg">
          {/* TODO: Confirm if this YouTube link is correct and if direct embedding is preferred or a placeholder image with a link. */}
          <iframe
            src="https://www.youtube.com/embed/-xJI27rfnvA"
            title="Video on Collaborating with Political Leaders"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="w-full h-full"
          ></iframe>
        </div>

        {/* Image linking to Google Drive Document - Styled like a video embed */}
        <div className="aspect-w-16 aspect-h-9 h-[50vh] w-[50vw] mx-auto mb-10 rounded-lg overflow-hidden shadow-lg">
          <a
            href="https://drive.google.com/file/d/1YUd5hKcVY5lCyESrF9xOTvReXkU9pt5N/view"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full h-full hover:opacity-90 transition-opacity"
          >
            {/* TODO: Consider downloading this image and hosting locally. */}
            <img
              src="https://www.dropbox.com/scl/fi/8fpc7m7g9kcmogeo4svjv/Screen-Shot-2021-08-05-at-12.31.20-AM-1024x567.png?rlkey=yih4f0e0u5htzxxwsyuj8l1jq&dl=0&dl=1"
              alt="Preview of a document related to political collaboration - Click to view"
              className="w-full h-full object-cover rounded-lg"
            />
          </a>
        </div>

        {/* Optional: Add more descriptive text if needed */}
        {/* <p className="mt-8">
          Further information and resources on how to effectively engage with political leaders...
        </p> */}
      </div>

      {/* All Done Button */}
      <div className="mt-16 mb-8 text-center">
        <Link
          to="/toolkit/community" // Link back to Community Section Page
          className="bg-[#A6410A] hover:bg-[#894d35] text-white rounded-md px-8 py-3 text-lg font-semibold transition-colors duration-200 shadow-lg hover:shadow-xl"
        >
          All done? Click here to return to Community Resources
        </Link>
      </div>
    </ToolkitPageLayout>
  )
}
